@import '@hevoio/hevo-ui-toolkit/styles/variables';

.hide {
  position: absolute !important;
  top: $spacer * 1.25;
  left: $spacer * 1.25;
}
